export const GET_ACTIVITY_FEED = `pages/coach/activityFeed/getActivityFeed`
